import { Integration_Service_Names_Enum } from '@main/graphql/types.admin.generated';

import { IntegrationService } from '../../../../lib';
import { DatadogConnector } from '../../connector';

export const DatadogService = IntegrationService.make({
  connector: DatadogConnector,
  name: Integration_Service_Names_Enum.Datadog,
});
